import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slotsContainer", "overrideFields"];
  static values = {
    slotsUrl: String,
  };

  connect() {
    this.appointmentTypeSelect = this.element.querySelector(
      "[data-appointment-type-select]"
    );
    this.dateInput = this.element.querySelector("[data-appointment-date]");
    this.overrideCheckbox = this.element.querySelector(
      "[data-appointment-override]"
    );

    if (this.appointmentTypeSelect) {
      this.appointmentTypeSelect.addEventListener(
        "change",
        () => this.loadSlots()
      );
    }
    if (this.dateInput) {
      this.dateInput.addEventListener("change", () => this.loadSlots());
    }
    if (this.overrideCheckbox) {
      this.overrideCheckbox.addEventListener("change", () =>
        this.toggleOverrideFields()
      );
    }

    this.toggleOverrideFields();
  }

  async loadSlots() {
    const typeId = this.appointmentTypeSelect?.value;
    const date = this.dateInput?.value;

    if (!typeId || !date) {
      if (this.hasSlotsContainerTarget) {
        this.slotsContainerTarget.innerHTML =
          '<p class="text-sm text-gray-500">Select an appointment type and date to see available slots.</p>';
      }
      return;
    }

    const url = `${this.slotsUrlValue}?appointment_type_id=${typeId}&date=${date}`;

    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      const html = await response.text();
      if (this.hasSlotsContainerTarget) {
        this.slotsContainerTarget.innerHTML = html;
        this.bindSlotButtons();
      }
    } catch {
      if (this.hasSlotsContainerTarget) {
        this.slotsContainerTarget.innerHTML =
          '<p class="text-sm text-red-500">Failed to load slots.</p>';
      }
    }
  }

  bindSlotButtons() {
    const hiddenInput = this.element.querySelector(
      'input[name="appointment[time_slot]"]'
    );
    const buttons =
      this.slotsContainerTarget.querySelectorAll("[data-slot-time]");

    buttons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        buttons.forEach((b) => {
          b.classList.remove(
            "ring-2",
            "ring-primary-500",
            "bg-primary-50",
            "dark:bg-primary-900/30"
          );
        });
        btn.classList.add(
          "ring-2",
          "ring-primary-500",
          "bg-primary-50",
          "dark:bg-primary-900/30"
        );
        if (hiddenInput) {
          hiddenInput.value = btn.dataset.slotTime;
        }
      });
    });
  }

  toggleOverrideFields() {
    if (!this.hasOverrideFieldsTarget || !this.overrideCheckbox) return;

    if (this.overrideCheckbox.checked) {
      this.overrideFieldsTarget.classList.remove("hidden");
      const buttons =
        this.slotsContainerTarget?.querySelectorAll("[data-slot-time]");
      buttons?.forEach((btn) => {
        btn.disabled = false;
        btn.classList.remove("opacity-50", "cursor-not-allowed");
      });
    } else {
      this.overrideFieldsTarget.classList.add("hidden");
    }
  }
}
